import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import Footer from './parts/layout/footer';
import Header from './parts/layout/header';
import ContentLoadingAnimations from './parts/layout/content-loading-animations';
import NavigationArrows from './parts/components/navigation-arrow';
import anchorsScroll from './parts/components/anchor-scroll';
import titleDecoLines from './parts/components/title-deco-lines';
import Cursor from './parts/components/cursor';
import magicScroll from "./parts/components/magic-scroll";

let prevScrollpos = window.scrollY;

window.addEventListener('load', () => {
  titleDecoLines.init();
  Footer.init();
  Header.init();
  NavigationArrows.init();
  anchorsScroll.init();
  ContentLoadingAnimations.init();

  window.onscroll = function () {
    var currentScrollPos = window.scrollY;
    let isadmin = document.querySelector('[data-header-js]').closest('.admin-bar');
    let offset = isadmin ? document.querySelector('[data-header-js]').clientHeight + 32 : document.querySelector('[data-header-js]').clientHeight;

    if (prevScrollpos > currentScrollPos) {
      let size = window.innerWidth < 782 ? "0" : "32px";
      document.querySelector('[data-header-js]').style.top = isadmin ? size : "0";
    }

    if (prevScrollpos < currentScrollPos && currentScrollPos > 200) {
      document.querySelector('[data-header-js]').style.top = "-" + offset + "px";
    }
    prevScrollpos = currentScrollPos;
  };

  magicScroll.init("nav-main", "#nav-main .desktop-only.header__nav li a", ".header__nav.desktop-only");
  magicScroll.init("nav-main", "#nav-main .desktop-only.common-lang-nav li a", ".common-lang-nav.desktop-only");

  const cursor = new Cursor;
  cursor.init();
});


function refreshScrollTriggerOnScreenWidthChange() {
  let screenWidth = window.innerWidth;

  window.addEventListener('resize', () => {
    const newScreenWidth = window.innerWidth;

    if (newScreenWidth !== screenWidth) {
      ScrollTrigger.refresh();
      screenWidth = newScreenWidth;
    }
  });
}

refreshScrollTriggerOnScreenWidthChange();
